import type {
  RequestOptions,
  ListRequestOptions,
  PagedListOptions
} from './types'

export const DEFAULT_REQUEST_OPTIONS: Partial<RequestOptions> = {
  cache: false
}

export const DEFAULT_LIST_ITEM_REQUEST_OPTIONS: Partial<RequestOptions> = {}

export const DEFAULT_SINGLE_ITEM_REQUEST_OPTIONS: Partial<RequestOptions> = {}

export const DEFAULT_LIST_REQUEST_OPTIONS: Partial<ListRequestOptions> = {}

export const DEFAULT_PAGED_LIST_OPTIONS: Partial<PagedListOptions> = {
  paginationType: 'page',
  requestOptions: {
    query: {
      perPage: 20
    },
    pagination: true
  }
}
